import { Gauge, Clock } from "lucide-react";

const Bar = ({ l, v, c }) => (
  <div>
    <div className="flex justify-between text-xs font-semibold text-[#4A6358]"><span>{l}</span><b className="text-[#0D3B2B]">{v == null ? "—" : `${v}%`}</b></div>
    <div className="mt-1 h-2 overflow-hidden rounded-full bg-[#EAEFEA]"><div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${v || 0}%`, background: c }} /></div>
  </div>
);

export const PartnerPerformance = ({ perf }) => {
  if (!perf) return null;
  const m = perf.month;
  const tone = m.score == null ? "#7B968B" : m.score >= 80 ? "#2E9E6B" : m.score >= 50 ? "#E0A43A" : "#E05C3A";
  return (
    <div className="space-y-3 rounded-3xl border border-[#D2E0D8] bg-white p-4" data-testid="partner-performance">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-2 font-bold text-[#0D3B2B]"><Gauge className="h-5 w-5 text-[#2E9E6B]" />My performance · 30 days</p>
        <span className="rounded-full px-3 py-1 text-sm font-extrabold text-white" style={{ background: tone }} data-testid="partner-work-score">{m.score == null ? "New" : `${m.score}%`}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 text-center">
        {[["Received", m.offered, "received"], ["Accepted", m.accepted, "accepted"], ["Declined", m.declined, "declined"], ["Missed", m.expired, "missed"]].map(([l, v, k]) => (
          <div key={k} className="rounded-2xl bg-[#F4F8F5] p-2"><p className="font-display text-xl font-extrabold text-[#0D3B2B]" data-testid={`partner-perf-${k}`}>{v}</p><p className="text-[10px] text-[#7B968B]">{l}</p></div>
        ))}
      </div>
      <Bar l="Acceptance rate" v={m.acceptance_pct} c="#2E9E6B" />
      <Bar l={`Completion rate (${m.completed} done, ${m.not_completed} couldn't complete)`} v={m.completion_pct} c="#0D3B2B" />
      <p className="text-[11px] text-[#7B968B]">Work score = 60% acceptance + 40% completion. Higher scores get nearby pickups first. All time: {perf.all.accepted}/{perf.all.offered} accepted.</p>
    </div>
  );
};

export const ServiceHours = ({ h, online }) => (h && online && !h.now_open ? (
  <p className="flex items-start gap-2 rounded-2xl bg-[#EEF5FF] p-3 text-sm text-[#1E3A8A]" data-testid="partner-service-closed">
    <Clock className="mt-0.5 h-4 w-4 shrink-0" />Pickup requests are sent between {h.open % 12 || 12} {h.open < 12 ? "AM" : "PM"} and {h.close % 12 || 12} {h.close < 12 || h.close === 24 ? "AM" : "PM"}. Bookings made now will reach you when service opens. Stay online.
  </p>
) : null);
